import { request, getApiUrl } from '@/utils/ajax';
import { CatalogGroup, Project, OptionalId, ProjectTag } from '@/types';

export interface ProfileCatalogDto {
    profileId: number;
    name: string;
    productCount: number;
}

export function getAvailableCatalogs(currency: string, query?: string): Promise<ProfileCatalogDto[]> {
    return request(`api/profile-catalog`, { query: { currency, query } }).then((x) => x.json());
}
